import type { FaireProductEntity } from "../../entity_types/product";

export const p_zka3h6knqa: FaireProductEntity = {
  token: "p_zka3h6knqa",
  type: "product",
  name: "Moroccan Visage Salad Bowl",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/3083614ed4fe2084463a7d2cb74aafc99b3d818c109a8f39192ef3aba38ccff3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5af8a9c8d21402631be968a221916dd563b744b324b3b998451e3d378ce843d.jpeg",
  ],
  priceDollars: 30,
  description:
    "This unique ceramic salad bowl from Morocco combines artisanal craftsmanship with modern artistry. Handmade and hand-painted by skilled Moroccan artisans, each bowl features a one-of-a-kind abstract face design that brings a touch of contemporary elegance to your table. With its smooth ceramic finish and distinctive lines, this piece is perfect for serving salads, fruit, or shared dishes, while also doubling as a striking decorative accent when not in use.\n\nBring a piece of Morocco’s vibrant culture and artistic spirit into your home with this beautifully expressive and functional bowl.\n\nDue to the handmade nature of this piece, slight variations in color, shape, and design are to be expected and celebrated.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:25.416Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
